export default "__VITE_ASSET__BtjzIi6b__"